export type TipoDeConexaoDeImpressora = 'USB' | 'REDE'

export type LinguagemDeImpressora = 'ZPL' | 'TSPL' | 'EPL' | 'PPLA' | 'PPLB'

export const linguagensDeImpressora: {
	valor: LinguagemDeImpressora
	rotulo: string
	fabricantes: string
	imprime: boolean
	extensaoDeArquivo: string
}[] = [
	{ valor: 'ZPL', rotulo: 'ZPL', fabricantes: 'Zebra e compatíveis', imprime: true, extensaoDeArquivo: 'zpl' },
	{ valor: 'TSPL', rotulo: 'TSPL', fabricantes: 'TSC, Elgin, Argox', imprime: true, extensaoDeArquivo: 'tspl' },
	{ valor: 'EPL', rotulo: 'EPL', fabricantes: 'Zebra antiga', imprime: true, extensaoDeArquivo: 'epl' },
	{ valor: 'PPLA', rotulo: 'PPLA', fabricantes: 'Argox (firmware PPLA), Datamax', imprime: true, extensaoDeArquivo: 'ppla' },
	{ valor: 'PPLB', rotulo: 'PPLB', fabricantes: 'Argox (firmware PPLB)', imprime: true, extensaoDeArquivo: 'pplb' },
]

export function extensaoDeArquivoDaLinguagem(linguagem: LinguagemDeImpressora): string {
	return linguagensDeImpressora.find(item => item.valor === linguagem)?.extensaoDeArquivo ?? 'txt'
}

export interface EstacaoDeImpressao {
	id: string
	identificador: string | null
	lojaId: string
	nome: string
	tipoDeConexao: TipoDeConexaoDeImpressora
	identificadorDaImpressora: string
	linguagem: LinguagemDeImpressora
	dpi: number
	queueUrl: string | null
	queueArn: string | null
	ativo: boolean
}

export const dpisDeImpressoraTermica = [203, 300, 600]

export const DPI_PADRAO_DE_IMPRESSORA = 203
export interface UnidadeDeImpressaoDeEtiqueta {
	indice: number
	quantidadeDeEtiquetas: number
	conteudo: string
}

export interface FatiaDeImpressaoDeEtiquetas {
	sequencia: number
	unidades: UnidadeDeImpressaoDeEtiqueta[]
	quantidadeDeEtiquetas: number
}

export const TAMANHO_MAXIMO_DO_NOME = 60
export const TAMANHO_MAXIMO_DO_IDENTIFICADOR = 100

export function criarEstacaoDeImpressao(lojaId: string): EstacaoDeImpressao {
	return {
		id: '',
		identificador: null,
		lojaId,
		nome: '',
		tipoDeConexao: 'USB',
		identificadorDaImpressora: '',
		linguagem: 'ZPL',
		dpi: DPI_PADRAO_DE_IMPRESSORA,
		queueUrl: null,
		queueArn: null,
		ativo: true,
	}
}

export type StatusDoJobDeImpressao = 'ENFILEIRANDO' | 'ENFILEIRADO' | 'CONCLUIDO' | 'PARCIAL' | 'FALHOU' | 'CANCELADO'

export type StatusDaFatiaDeImpressao = 'ENFILEIRADA' | 'ENTREGUE_AO_SPOOL' | 'IMPRESSA' | 'FALHOU' | 'DESCARTADA'

export interface FatiaDoJobDeImpressao {
	id: string
	jobDeImpressaoId: string
	sequencia: number
	quantidadeDeEtiquetas: number
	status: StatusDaFatiaDeImpressao
	tentativas: number
	erro: string | null
}

export interface JobDeImpressaoNoHistorico {
	id: string
	dataHora: string
	estacaoDeImpressaoId: string
	modeloDeEtiquetaId: string
	quantidadeDeEtiquetas: number
	quantidadeConfirmada: number
	totalDeFatias: number
	status: StatusDoJobDeImpressao
	fatias: FatiaDoJobDeImpressao[]
}

export interface ResultadoDeEnvioParaImpressao {
	jobId: string
	quantidadeDeEtiquetas: number
	totalDeFatias: number
}

export const situacoesDoJobDeImpressao: Record<StatusDoJobDeImpressao, { rotulo: string; cor: string }> = {
	ENFILEIRANDO: { rotulo: 'Enviando', cor: 'grey' },
	ENFILEIRADO: { rotulo: 'Na fila', cor: 'info' },
	CONCLUIDO: { rotulo: 'Impresso', cor: 'success' },
	PARCIAL: { rotulo: 'Saiu em parte', cor: 'warning' },
	FALHOU: { rotulo: 'Não saiu', cor: 'error' },
	CANCELADO: { rotulo: 'Cancelado', cor: 'grey' },
}

export interface HistoricoDeEmissaoDeEtiqueta {
	id: string
	dataHora: string
	lojaId: string
	lojaNome: string
	modeloId: string
	modeloDescricao: string
	estacaoId: string | null
	estacaoNome: string
	idTabelas: string[]
	parcelasPorTabela: Record<string, number>
	itens: {
		produtoId: string
		sku: string
		ean?: string
		nomeDoProduto: string
		quantidade: number
	}[]
}
